/**
 * time 2019/03/13
 * author htd
 **/

import { getRunTime } from '../../../public-resource/libs/utils/index'

// 判断环境
let HOST = getRunTime('//m.xinli001.com')

module.exports = {
  isLogin: `${HOST}/ajax/get-user-header`,
  like: `${HOST}/qa/like-question-answer.json`,
  follow: `${HOST}/ajax/user-follow-toggle1.json`,
  login: `${HOST}/account/login`,
  pay: `${HOST}/zhifu/reward-create-dingdan`, // 订单生成
  payStatus: `${HOST}/zhifu/reward-pay-callback`, // 查询是否支付成功
  feeling: `${HOST}/qa/qa-same-feeling-toggle.json` // 同感切换
}



// WEBPACK FOOTER //
// ./src/pages/promotion/template/api.js